
import { component } from '@/helpers/vueTyped';

export default component()({
  name: 'ScoreCardGhostLoader',

  functional: true,

  render(h, context) {
    return (
      <div
        class='scorecard-ghost-loader'
        ref={context.data.ref}
        on={context.listeners}
        {...{ directives: context.data.directives }}
      />
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-4670c4dd/ScoreCardGhostLoader.vue" });